import { createSlice } from "@reduxjs/toolkit";

const initialBonusState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    bonusForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const bonusSlice = createSlice({
    name: "bonuses",
    initialState: initialBonusState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getBonusById
        bonusFetched: (state, action) => {
            state.actionsLoading = false;
            state.bonusForEdit = action.payload.bonusForEdit;
            state.floorPlans = action.payload.bonusForEdit.floorPlans;
            state.error = null;

        },
        // getBonusChart
        bonusChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.bonusChart = action.payload.bonusChart;
            state.error = null;

        },
        // getBonusChart
        bonusHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.bonusChartHour = action.payload.bonusChartHour;
            state.error = null;

        },
        // getBonusChart
        bonusHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.bonusChartHourZone = action.payload.bonusChartHourZone;
            state.error = null;

        },
        // get list data
        bonusesFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.bonusForEdit = undefined;
            state.floorPlans = undefined;
            state.bonusChart = undefined;
            state.bonusChartHour = undefined;
            state.bonusChartHourZone = undefined;
        },
        // createBonus
        bonusCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateBonus
        bonusUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // bonusDeleted
        bonusDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
